module.exports = __webpack_public_path__ + "img/total-revenue-icon.e3a0d290.svg";